import React from "react";
import { Link, useHistory } from "react-router-dom";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Chip from "@mui/material/Chip";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PersonIcon from "@mui/icons-material/PersonOutlined";
import ExitIcon from "@mui/icons-material/ExitToAppOutlined";
import Badge from "@mui/material/Badge";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { ROUTES } from "constants/routes";
import ConfigurationContext from "../../../../contexts/ConfigurationContext";
import { useTheme } from "@mui/material/styles";
import AuthContext from "../../../../contexts/AuthContext";
import Logo from "../../../Global/Logo";
import MenuPopupState from "./menudropdown";
import ProfileContext from "contexts/ProfileContext";
import MessagingContext from "contexts/MessagingContext";
import Grid from "@mui/material/Grid";

export const Header = props => {
  const history = useHistory();
  const { isAuthenticated, user, logout } = React.useContext(AuthContext);
  const { profile, clearAllProfiles } = React.useContext(ProfileContext);
  const theme = useTheme();
  const { onToggle } = props || {};
  const { configurations, isFeatureEnabled } = React.useContext(ConfigurationContext);
  const { unreadCount } = React.useContext(MessagingContext);
  // console.log(user);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ background: "#ffffff" }}>
        <Toolbar sx={{ mb: 1.8 }}>
          <IconButton
            size="large"
            edge="start"
            color="secondary"
            onClick={onToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component="div"
            sx={{
              flexGrow: 1,
              maxWidth: "calc(90vw - 2em)",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Link role="button" to="/">
              <Logo variant="left" />
            </Link>
          </Box>

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            {configurations?.school?.enrollment_url ? (
              <div style={{ display: "flex" }}>
                <svg
                  width="19"
                  height="42"
                  viewBox="0 0 19 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginTop: "5px" }}
                >
                  <g clipPath="url(#clip0_2_190)">
                    <path
                      d="M13.513 40.5387C13.4778 40.6445 13.4637 40.7562 13.4716 40.8675C13.4795 40.9788 13.5091 41.0874 13.5589 41.1871C13.6086 41.2869 13.6775 41.3759 13.7615 41.449C13.8456 41.5221 13.9432 41.5778 14.0487 41.6131C14.2596 41.6852 14.4903 41.6711 14.6908 41.5737C14.8914 41.4764 15.0456 41.3037 15.1201 41.0932L16.6061 36.7088C16.6438 36.6031 16.6597 36.4909 16.653 36.3789C16.6463 36.2668 16.617 36.1574 16.5669 36.057C16.5169 35.9566 16.4471 35.8674 16.3618 35.7948C16.2765 35.7222 16.1774 35.6676 16.0705 35.6344C15.8596 35.5623 15.6289 35.5764 15.4283 35.6737C15.2278 35.7711 15.0736 35.9437 14.9991 36.1543L13.513 40.5387ZM0.84674 20.3325C0.622175 20.3325 0.40681 20.422 0.248018 20.5812C0.0892271 20.7405 7.85791e-06 20.9564 7.86776e-06 21.1816C7.8776e-06 21.4068 0.0892272 21.6228 0.248019 21.7821C0.40681 21.9413 0.622175 22.0307 0.84674 22.0307L5.40868 22.0307C5.63324 22.0307 5.84861 21.9413 6.0074 21.7821C6.16619 21.6228 6.25541 21.4068 6.25541 21.1816C6.25541 20.9564 6.16619 20.7405 6.0074 20.5812C5.84861 20.422 5.63324 20.3325 5.40868 20.3325L0.777632 20.3325L0.84674 20.3325ZM3.11042 12.153C3.00839 12.1069 2.89826 12.0815 2.7864 12.0783C2.67453 12.0752 2.56318 12.0943 2.45873 12.1346C2.35428 12.1749 2.25882 12.2356 2.17789 12.3131C2.09696 12.3906 2.03217 12.4834 1.98723 12.5862C1.94159 12.6873 1.91656 12.7965 1.91364 12.9074C1.91072 13.0183 1.92994 13.1287 1.9702 13.232C2.01045 13.3354 2.07093 13.4296 2.14804 13.5092C2.22516 13.5887 2.31736 13.652 2.41923 13.6953L6.63557 15.5842C6.7376 15.6303 6.84771 15.6556 6.95957 15.6588C7.07143 15.6619 7.18282 15.6428 7.28726 15.6025C7.39171 15.5622 7.48715 15.5016 7.56808 15.4241C7.64901 15.3466 7.71383 15.2537 7.75876 15.1509C7.80472 15.0486 7.83001 14.9382 7.83315 14.826C7.83628 14.7138 7.81721 14.6021 7.77704 14.4974C7.73687 14.3926 7.67637 14.2969 7.59908 14.2158C7.5218 14.1346 7.42925 14.0696 7.32676 14.0245L3.11042 12.153ZM8.65733 5.5331C8.49876 5.37542 8.28448 5.28697 8.06117 5.28697C7.83786 5.28697 7.62358 5.37542 7.46501 5.5331C7.29577 5.68038 7.19164 5.88891 7.17544 6.11304C7.15925 6.33717 7.2323 6.55862 7.3786 6.72883L10.4544 10.1947C10.613 10.3524 10.8273 10.4409 11.0506 10.4409C11.2739 10.4409 11.4882 10.3524 11.6468 10.1947C11.804 10.0357 11.8922 9.82081 11.8922 9.59686C11.8922 9.37291 11.804 9.15802 11.6468 8.99899L8.5882 5.5331L8.65733 5.5331ZM17.0381 1.61662C17.0102 1.5087 16.961 1.40753 16.8933 1.31908C16.8256 1.23064 16.7409 1.15674 16.6442 1.10178C16.5475 1.04682 16.4408 1.0119 16.3303 0.999128C16.2199 0.986356 16.108 0.99598 16.0014 1.02742C15.8938 1.05541 15.7928 1.10483 15.7046 1.1727C15.6165 1.24057 15.5428 1.32553 15.488 1.42253C15.4332 1.51952 15.3984 1.62655 15.3856 1.7373C15.3729 1.84805 15.3825 1.96024 15.4138 2.0672L16.6234 6.52089C16.6516 6.62913 16.7007 6.73073 16.7681 6.81985C16.8355 6.90897 16.9198 6.98386 17.0162 7.04022C17.1125 7.09658 17.219 7.13331 17.3295 7.14827C17.4401 7.16323 17.5524 7.15616 17.6602 7.12743C17.8757 7.06649 18.0593 6.92401 18.1721 6.73005C18.2849 6.53609 18.3182 6.30578 18.265 6.08765L17.0381 1.61662ZM2.41923 29.6211C2.31968 29.6691 2.23069 29.7365 2.15748 29.8194C2.08428 29.9024 2.02831 29.9992 1.9929 30.1041C1.95749 30.209 1.94334 30.32 1.95127 30.4305C1.95919 30.541 1.98905 30.6487 2.03907 30.7475C2.08534 30.8488 2.15146 30.9398 2.23348 31.015C2.31549 31.0902 2.41173 31.1481 2.5165 31.1853C2.62127 31.2225 2.73242 31.2382 2.84335 31.2314C2.95428 31.2247 3.06274 31.1957 3.16226 31.1461L7.30949 29.0839C7.40904 29.0359 7.49803 28.9684 7.57124 28.8855C7.64445 28.8025 7.70039 28.7058 7.7358 28.6008C7.77121 28.4959 7.78536 28.385 7.77743 28.2745C7.76951 28.164 7.73968 28.0562 7.68966 27.9574C7.59256 27.756 7.42009 27.6012 7.20977 27.5265C6.99945 27.4519 6.76826 27.4635 6.56644 27.5588L2.41923 29.6211ZM7.82787 37.1074C7.75935 37.196 7.709 37.2973 7.67972 37.4055C7.65043 37.5137 7.64279 37.6266 7.65725 37.7377C7.67171 37.8489 7.70798 37.9561 7.76396 38.0532C7.81994 38.1502 7.89453 38.2352 7.98341 38.3031C8.16067 38.4365 8.38299 38.4949 8.60268 38.4657C8.82236 38.4366 9.02189 38.3222 9.15845 38.1472L11.9751 34.4733C12.0446 34.3858 12.0961 34.2854 12.1268 34.1779C12.1574 34.0703 12.1666 33.9578 12.1537 33.8467C12.1409 33.7355 12.1063 33.6281 12.0519 33.5304C11.9975 33.4327 11.9245 33.3469 11.8369 33.2776C11.6568 33.1432 11.4317 33.0843 11.2092 33.1135C10.9867 33.1426 10.7842 33.2574 10.6445 33.4336L7.82787 37.1074Z"
                      fill={theme.palette.secondary.main}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2_190">
                      <rect
                        width="40.7589"
                        height="18.2823"
                        fill="white"
                        transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0.90625)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <Button
                  role="button"
                  variant="contained"
                  color="secondary"
                  className="MuiButton-enroll"
                  target="_blank"
                  sx={{ color: "#fff" }}
                  href={
                    configurations?.school?.enrollment_url
                      ? configurations?.school?.enrollment_url.toLowerCase().startsWith("http")
                        ? configurations?.school?.enrollment_url
                        : `https://${configurations?.school?.enrollment_url}`
                      : "#"
                  }
                >
                  {configurations?.enroll_button_text ? (
                    <Grid>
                      <Typography
                        textTransform={"none"}
                        // fontWeight={"700"}
                        fontWeight={"600"}
                        fontSize={{ xs: 20, md: 20, sm: 10 }}
                        sx={{
                          color: "#fff",
                        }}
                      >
                        {configurations.enroll_button_text}
                      </Typography>
                    </Grid>
                  ) : (
                    <Grid style={{ textAlign: "center" }}>
                      <Typography
                        color="#fff"
                        textTransform={"none"}
                        fontWeight={"600"}
                        fontSize={{ xs: 20, md: 13, sm: 10 }}
                      >
                        Apply to
                      </Typography>
                      <Typography
                        textTransform={"none"}
                        // fontWeight={"700"}
                        fontWeight={"600"}
                        fontSize={{ xs: 20, md: 20, sm: 10 }}
                        sx={{
                          color: "#fff",
                        }}
                      >
                        {configurations.schoolName ? configurations.schoolName : ""}
                      </Typography>
                    </Grid>
                  )}
                </Button>
                <svg
                  width="19"
                  height="42"
                  viewBox="0 0 19 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginTop: "5px" }}
                >
                  <g clipPath="url(#clip0_3681_9391)">
                    <path
                      d="M5.48698 40.5387C5.52219 40.6445 5.53627 40.7562 5.5284 40.8675C5.52053 40.9788 5.49087 41.0874 5.44113 41.1871C5.39138 41.2869 5.32251 41.3759 5.23847 41.449C5.15442 41.5221 5.05684 41.5778 4.9513 41.6131C4.74043 41.6852 4.50973 41.6711 4.30918 41.5737C4.10863 41.4764 3.95441 41.3037 3.87994 41.0932L2.39386 36.7088C2.35621 36.6031 2.34026 36.4909 2.347 36.3789C2.35374 36.2668 2.38302 36.1574 2.43307 36.057C2.48311 35.9566 2.55291 35.8674 2.63823 35.7948C2.72355 35.7222 2.82264 35.6676 2.92954 35.6344C3.1404 35.5623 3.37111 35.5764 3.57166 35.6737C3.77221 35.7711 3.92643 35.9437 4.00089 36.1543L5.48698 40.5387ZM18.1533 20.3325C18.3778 20.3325 18.5932 20.422 18.752 20.5812C18.9108 20.7405 19 20.9564 19 21.1816C19 21.4068 18.9108 21.6228 18.752 21.7821C18.5932 21.9413 18.3778 22.0307 18.1533 22.0307L13.5913 22.0307C13.3668 22.0307 13.1514 21.9413 12.9926 21.7821C12.8338 21.6228 12.7446 21.4068 12.7446 21.1816C12.7446 20.9564 12.8338 20.7405 12.9926 20.5812C13.1514 20.422 13.3668 20.3325 13.5913 20.3325L18.2224 20.3325L18.1533 20.3325ZM15.8896 12.153C15.9916 12.1069 16.1017 12.0815 16.2136 12.0783C16.3255 12.0752 16.4368 12.0943 16.5413 12.1346C16.6457 12.1749 16.7412 12.2356 16.8221 12.3131C16.903 12.3906 16.9678 12.4834 17.0128 12.5862C17.0584 12.6873 17.0834 12.7965 17.0864 12.9074C17.0893 13.0183 17.0701 13.1287 17.0298 13.232C16.9896 13.3354 16.9291 13.4296 16.852 13.5092C16.7748 13.5887 16.6826 13.652 16.5808 13.6953L12.3644 15.5842C12.2624 15.6303 12.1523 15.6556 12.0404 15.6588C11.9286 15.6619 11.8172 15.6428 11.7127 15.6025C11.6083 15.5622 11.5129 15.5016 11.4319 15.4241C11.351 15.3466 11.2862 15.2537 11.2412 15.1509C11.1953 15.0486 11.17 14.9382 11.1669 14.826C11.1637 14.7138 11.1828 14.6021 11.223 14.4974C11.2631 14.3926 11.3236 14.2969 11.4009 14.2158C11.4782 14.1346 11.5708 14.0696 11.6732 14.0245L15.8896 12.153ZM10.3427 5.5331C10.5013 5.37542 10.7155 5.28697 10.9388 5.28697C11.1621 5.28697 11.3764 5.37542 11.535 5.5331C11.7042 5.68038 11.8084 5.88891 11.8246 6.11304C11.8408 6.33717 11.7677 6.55862 11.6214 6.72883L8.54556 10.1947C8.38698 10.3524 8.17271 10.4409 7.94939 10.4409C7.72608 10.4409 7.51181 10.3524 7.35323 10.1947C7.196 10.0357 7.10778 9.82081 7.10778 9.59686C7.10778 9.37291 7.196 9.15802 7.35323 8.99899L10.4118 5.5331L10.3427 5.5331ZM1.96186 1.61662C1.98977 1.5087 2.03902 1.40753 2.10669 1.31908C2.17437 1.23064 2.25909 1.15674 2.35581 1.10178C2.45253 1.04682 2.55925 1.0119 2.66969 0.999128C2.78012 0.986356 2.89199 0.99598 2.99865 1.02742C3.10625 1.05541 3.20716 1.10483 3.29536 1.1727C3.38355 1.24057 3.45724 1.32553 3.51204 1.42253C3.56685 1.51952 3.60164 1.62655 3.61438 1.7373C3.62711 1.84805 3.61754 1.96024 3.58619 2.0672L2.37656 6.52089C2.34844 6.62913 2.29928 6.73073 2.23189 6.81985C2.16449 6.90897 2.08019 6.98386 1.98385 7.04022C1.88751 7.09658 1.78101 7.13331 1.67047 7.14827C1.55994 7.16323 1.44757 7.15616 1.33977 7.12743C1.12427 7.06649 0.940756 6.92401 0.827934 6.73005C0.715111 6.53609 0.681778 6.30578 0.734962 6.08765L1.96186 1.61662ZM16.5808 29.6211C16.6803 29.6691 16.7693 29.7365 16.8425 29.8194C16.9157 29.9024 16.9717 29.9992 17.0071 30.1041C17.0425 30.209 17.0567 30.32 17.0487 30.4305C17.0408 30.541 17.011 30.6487 16.9609 30.7475C16.9147 30.8488 16.8485 30.9398 16.7665 31.015C16.6845 31.0902 16.5883 31.1481 16.4835 31.1853C16.3787 31.2225 16.2676 31.2382 16.1567 31.2314C16.0457 31.2247 15.9373 31.1957 15.8377 31.1461L11.6905 29.0839C11.591 29.0359 11.502 28.9684 11.4288 28.8855C11.3556 28.8025 11.2996 28.7058 11.2642 28.6008C11.2288 28.4959 11.2146 28.385 11.2226 28.2745C11.2305 28.164 11.2603 28.0562 11.3104 27.9574C11.4075 27.756 11.5799 27.6012 11.7902 27.5265C12.0006 27.4519 12.2318 27.4635 12.4336 27.5588L16.5808 29.6211ZM11.1721 37.1074C11.2407 37.196 11.291 37.2973 11.3203 37.4055C11.3496 37.5137 11.3572 37.6266 11.3428 37.7377C11.3283 37.8489 11.292 37.9561 11.236 38.0532C11.1801 38.1502 11.1055 38.2352 11.0166 38.3031C10.8393 38.4365 10.617 38.4949 10.3973 38.4657C10.1776 38.4366 9.97811 38.3222 9.84156 38.1472L7.0249 34.4733C6.95543 34.3858 6.9039 34.2854 6.87324 34.1779C6.84258 34.0703 6.83342 33.9578 6.84626 33.8467C6.85911 33.7355 6.89371 33.6281 6.94809 33.5304C7.00248 33.4327 7.07556 33.3469 7.16315 33.2776C7.34317 33.1432 7.56826 33.0843 7.79079 33.1135C8.01333 33.1426 8.21585 33.2574 8.35547 33.4336L11.1721 37.1074Z"
                      fill={theme.palette.secondary.main}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3681_9391">
                      <rect
                        width="40.7589"
                        height="18.2823"
                        fill="white"
                        transform="translate(19 0.90625) rotate(90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            ) : null}
          </Box>

          {!isFeatureEnabled("user_account") ? (
            ""
          ) : isAuthenticated ? (
            <>
              <IconButton size="small" sx={{ ml: 4 }} onClick={handleMenu}>
                <Badge
                  anchorOrigin={{ horizontal: "left", vertical: "top" }}
                  badgeContent={unreadCount}
                  color="primary"
                  sx={{ ".MuiBadge-badge": { color: "#FFF" } }}
                >
                  <PersonIcon />
                </Badge>
                <ArrowDownIcon />
              </IconButton>
              <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  className: "MuiPaper-profile-menu",
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {/* <Link to="/auth/profile?role=staff-profile"> */}
                <MenuItem>
                  <Avatar
                    src={profile?.profile_image?.path || "/assets/images/profiles-admin.svg"}
                  />
                  <Box ml={1} display="flex" textAlign="center" flexDirection="column">
                    <Typography mb={0.5}>
                      {user ? user?.first_name : ""} {user ? user?.last_name : ""}
                    </Typography>
                  </Box>
                </MenuItem>
                {/* </Link> */}
                <Divider />
                <Link to={ROUTES.MY_ACCOUNT}>
                  <MenuItem sx={{ mt: 1 }}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <Badge
                      anchorOrigin={{ horizontal: "right", vertical: "top" }}
                      badgeContent={unreadCount}
                      color="primary"
                      sx={{ ".MuiBadge-badge": { color: "#FFF" } }}
                    >
                      <ListItemText>My Account</ListItemText>
                    </Badge>
                  </MenuItem>
                </Link>
                <MenuPopupState />
                <Link
                  to={"/"}
                  onClick={e => {
                    e.preventDefault();
                    logout();
                    clearAllProfiles();
                    history.push(ROUTES.HOME);
                  }}
                >
                  <MenuItem sx={{ mt: 1 }}>
                    <ListItemIcon>
                      <ExitIcon />
                    </ListItemIcon>
                    <ListItemText>Log Out</ListItemText>
                  </MenuItem>
                </Link>
              </Menu>
            </>
          ) : (
            <Box
              ml={{ xs: "0", md: "40px" }}
              display="flex"
              alignItems="center"
              sx={{
                flexDirection: { xs: "column", sm: "row" },
                width: { xs: "unset", md: "unset" },
              }}
            >
              <Link to={ROUTES.SIGN_IN}>
                <Typography
                  color={theme.palette.secondary.main}
                  fontWeight="bolder"
                  sx={{
                    fontSize: { xs: "0.8rem", sm: "1rem" },
                    marginBottom: { xs: "20px", sm: "0" },
                  }}
                >
                  Log In
                </Typography>
              </Link>

              <Link to={ROUTES.SIGN_UP}>
                <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className="MuiButton-enroll"
                    sx={{
                      paddingY: "16px !important",
                      marginLeft: "2em",
                    }}
                  >
                    <Typography color="warning.main" fontWeight="bolder">
                      Sign Up
                    </Typography>
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: { xs: "block", sm: "block", md: "none" },
                    marginLeft: { sm: "30px" },
                    width: { xs: "110%", sm: "unset" },
                  }}
                >
                  <Typography
                    color={theme.palette.secondary.main}
                    fontWeight="bolder"
                    sx={{ fontSize: { xs: "0.8rem", sm: "1rem" } }}
                  >
                    Sign Up
                  </Typography>
                </Box>
              </Link>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
